import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ userData, children }) => {
  if (userData?.email) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
